module.exports = "/_next/static/images/d9bfa2bc0b907422ecd9c38850cb5cbd-cajitas-left-desktop.jpg.webp";